import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext } from 'react';
import {FormLayout} from '@shopify/polaris';
import SectionsSelect from './SectionsSelect';
import OrganizationsSelect from './OrganizationsSelect';
import { FormContext } from '@thinkwell/react.common'
import { Spinner, Select } from '@thinkwell/react.polaris'
import { SectionsContext } from './contexts/Sections'
import { OrganizationsContext } from './contexts/Organizations'

export default function SectionForm(props) {
  const form = useContext(FormContext)
  const [sections, fetchSections] = useContext(SectionsContext)
  const [organizations, fetchOrganizations] = useContext(OrganizationsContext)

  useEffect(() => {
    const doFetchOrganizations = async() => {
      const organizations = await fetchOrganizations('/admin/organizations.json')
      if (organizations && organizations.length) {
        const organizationId = form.field("organization_id")
        if(!organizations.find((org) => org.id == organizationId)) {
          const firstOrganizationId = organizations[0].id
          console.log(`select first org ${firstOrganizationId} ${organizationId ? `(from ${organizationId})` : ''}`)
          flushSync(() => {
            onOrganizationChange(firstOrganizationId)
          })
        } else {
          fetchSectionsForOrg(organizationId)
        }
      }
    }
    doFetchOrganizations()
  }, [])

  const onOrganizationChange = (value) => {
    form.onData("organization_id")(value)
    fetchSectionsForOrg(value)
  }

  const sectionsUrl = (organizationId) => `/admin/organizations/${organizationId}/sections.json`

  const fetchSectionsForOrg = async(organizationId) => {
    const sections = await fetchSections(sectionsUrl(organizationId))
    const sectionId = form.field('section_id')
    if (sections && sections.length && !sections.find((section) => (section.id || section.section_id) == sectionId)) {
      const firstSectionId = sections[0].id || sections[0].section_id
      console.log(`select first section ${firstSectionId} ${sectionId ? `(from ${sectionId})` : ''}`)
      flushSync(() => {
        form.onData('section_id')(firstSectionId)
      })
    }
  }

  return (
    <FormLayout>
      <OrganizationsSelect required
        onChange={onOrganizationChange}
      />
      <SectionsSelect required
        notFoundMessage={props.sectionsNotFoundMessage}
      />
    </FormLayout>
  );
}
